export enum PaymentStatus {
  Paid = "paid",
  Pending = "pending",
  Canceled = "canceled",
  Refunded = "refunded",
  Failed = "failed",
}

export const paymentStatusLabelMap: Record<string, string> = {
  [PaymentStatus.Paid]: "Pago",
  [PaymentStatus.Pending]: "Em aberto",
  [PaymentStatus.Canceled]: "Cancelado",
  [PaymentStatus.Refunded]: "Estornado",
  [PaymentStatus.Failed]: "Não autorizado",
};
